import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { purchaseHistoryApi, type CreatePurchaseHistoryPayload } from '@/lib/api/purchaseHistoryApi'

export const useGetPurchaseHistories = (params?: { productId?: string; vendorId?: string }, enabled = true) => {
  return useQuery({
    queryKey: ['purchase-histories', params],
    queryFn: () => purchaseHistoryApi.getPurchaseHistories(params),
    enabled,
  })
}

export const useCreatePurchaseHistory = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreatePurchaseHistoryPayload) => purchaseHistoryApi.createPurchaseHistory(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['purchase-histories'] })
    },
  })
}
